export class MarkMessageResolvedRequest {
  private Action = 'MarkMessageResolved';
  public PublicToken: string;
  public MessageId: number;

  constructor({ PublicToken, MessageId }) {
    this.PublicToken = PublicToken;
    this.MessageId = MessageId;
  }
}
